import { isApiError, isNetworkError } from '@brightlocal/api-client';

/**
 * True for a request that never got a response: a connectivity failure or an abort
 * (e.g. by TanStack Query). Client-side and not actionable, so reporting layers skip it.
 */
export const isNetworkApiError = (error: unknown) => isApiError(error) && isNetworkError(error);
